<template>
  <div class="site-footer">
    <div class="footer-content container">
      <div class="row align-items-stretch">
        <div class="col-md-5 d-flex flex-column">
          <div class="flex-grow-1">
            <div class="copyright flex-grow-1 align-self-stretch">&copy; Copyright {{ new Date().getFullYear() }} Tree Crossing, LLC</div>
          </div>
        </div>
      </div>
      <div class="row d-flex flex-row">
        <div class="col"><router-link to="/about" class="link-secondary align-self-stretch">About</router-link></div>
        <div class="col"><router-link to="/plans" class="link-secondary align-self-stretch">Plans</router-link></div>
        <div class="col"><router-link to="/support" class="link-secondary align-self-stretch">Support</router-link></div>
        <div class="col"><router-link to="/privacy" class="link-secondary align-self-stretch">Privacy</router-link></div>
        <div class="col"><router-link to="/terms" class="link-secondary align-self-stretch">Terms</router-link></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.site-footer{
  border-top: 1px solid rgb(233, 236, 239); // $border-color
  background-color: rgb(248, 249, 250); // $navbar-light-color
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  
  @media (min-width: 768px) {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.footer-content {
  height: auto;
  min-height: 5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  .copyright {
    color: #ccc;
    flex-shrink: 0; // don't wrap
    white-space: nowrap;
  }
}
.flex-grow-1 {
  flex-grow: 1;
}
.align-self-stretch {
  align-self: stretch;
}
</style>
